export const initMSW = async () => {
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_API_MOCKING === 'enabled'
  ) {
    const { worker } = await import('../mocks/browser');
    await worker.start({ onUnhandledRequest: 'bypass' });
  }
};
